// export const formateNumber = (number) => {
//     return new Intl.NumberFormat('tr-TR', {
//         style: 'currency',
//         currency: 'TRY',
//     }).format(number);
// };

export const formateNumber = (number) => {
    return new Intl.NumberFormat('en-US').format(number);
};